function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.703 3.75H8.578a.188.188 0 00-.187.188v1.5c0 .103.084.187.187.187h4.247l-3.656 12.75H5.367a.188.188 0 00-.187.188v1.5c0 .103.084.187.187.187h10.125a.188.188 0 00.188-.188v-1.5a.188.188 0 00-.188-.187H11.12l3.656-12.75h3.928a.188.188 0 00.188-.188v-1.5a.188.188 0 00-.188-.187z"
})));